import { useMutation } from '@tanstack/react-query';

import { publicApi } from 'api';

interface ActivateAccountParams {
  token: string;
  newPassword: string;
}

async function activateAccount({ token, newPassword }: ActivateAccountParams): Promise<void> {
  await publicApi.post('/public/auth/onboarding/activate', {
    token,
    newPassword,
  });
}

export function useActivateAccount() {
  return useMutation({
    mutationFn: activateAccount,
  });
}
